import React from 'react';
import { Segment } from 'components/segment/Segment';

export const CookiePolicySlice = () => {
  return (
    <Segment>
      <div id="cookie-policy-text" style={{ marginTop: '-5rem' }} />
    </Segment>
  );
};

export default CookiePolicySlice;
